export const getFileExtensionFromUrl = (url: string): string => {
  // 1. Extract the filename from the URL
  const filename = url.split('/').pop()?.split('?')[0].split('#')[0];

  // 2. Find the last occurrence of a dot
  const lastDotIndex = filename?.lastIndexOf('.') || -1;

  // 3. Check if a dot exists and it's not the first character (e.g., ".gitignore")
  if (lastDotIndex > 0) {
    // 4. Extract the substring after the last dot
    return filename?.substring(lastDotIndex + 1) || '';
  }

  // No extension found
  return '';
};
